import type { Dictionary } from "../../types";

export const en: Dictionary = {
  banner: {
    title: "Privacy settings",
    body:
      "We use cookies and similar technologies. Strictly necessary ones are always active. " +
      "Everything else only runs if you agree. You can change your choice at any time.",
    acceptAll: "Accept all",
    rejectAll: "Reject all",
    customize: "Settings",
    privacy: "Privacy policy",
    imprint: "Imprint",
  },
  prefs: {
    title: "Detailed privacy settings",
    intro:
      "Choose which categories you allow. Necessary services cannot be switched off, because " +
      "the site does not work without them.",
    save: "Save selection",
    acceptAll: "Accept all",
    rejectAll: "Reject all",
    close: "Close",
    alwaysActive: "Always active",
    provider: "Provider",
    purpose: "Purpose",
    retention: "Storage period",
    cookies: "Cookies",
    usTransfer: "Third-country transfer",
    usTransferNote:
      "Data is transferred to the USA, where the level of data protection is not equivalent to EU law.",
    privacyPolicy: "Provider's privacy policy",
    noVendors: "No services are integrated for this category.",
  },
  categories: {
    necessary: {
      title: "Necessary",
      description:
        "Required to operate the site: session handling, security, and storing this privacy " +
        "decision. These are set without consent under § 25 (2) TDDDG.",
    },
    functional: {
      title: "Functional",
      description:
        "Remembers settings such as language or region and enables embedded content like maps and videos.",
    },
    analytics: {
      title: "Statistics",
      description:
        "Measures which pages are visited and where visitors come from, so content can be improved " +
        "deliberately. Results are evaluated in aggregate.",
    },
    marketing: {
      title: "Marketing",
      description:
        "Tracks your behaviour across websites to deliver advertising and measure its performance. " +
        "This involves sending data to advertising networks.",
    },
  },
  /**
   * US opt-out copy. Notice, not a request: under CCPA/CPRA the processing is already
   * lawful, so wording it as a question ("may we…") would misdescribe what is happening
   * and make the opt-out look optional when it is the visitor's actual right.
   *
   * `optOut` keeps the statutory phrasing verbatim. California consumers are told by the
   * regulator to look for exactly this sentence, so it is not a string to improve.
   */
  us: {
    title: "Your privacy choices",
    body:
      "We use cookies and similar technologies to operate this site, measure how it is used, " +
      "and deliver advertising. You can opt out of the sale or sharing of your personal " +
      "information at any time.",
    optOut: "Do Not Sell or Share My Personal Information",
    acknowledge: "OK",
    revisit: "Your privacy choices",
    prefsIntro:
      "These categories are active unless you turn them off. Strictly necessary services " +
      "cannot be switched off, because the site does not work without them.",
    gpcHonoured:
      "Your browser sent a Global Privacy Control signal. We have applied it and opted you " +
      "out already — no action needed.",
    optedOut: "You are opted out.",
    necessary:
      "Required to operate the site: session handling, security, and storing your privacy " +
      "choice. These are never sold or shared.",
  },
  revisit: { label: "Privacy settings" },
  placeholder: {
    title: "External content",
    body:
      "This content is loaded from {provider}. Doing so transmits data to that provider, " +
      "including your IP address.",
    load: "Load content once",
    loadAlways: "Always allow {provider}",
  },
  a11y: {
    dialog: "Privacy notice",
    prefsDialog: "Detailed privacy settings",
  },
};
